import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Page, PageProps } from 'src/modules/newPrograms/components/Page';
import { ProgramPageFragment } from 'src/modules/newPrograms/documents/getProgram.generated';
import { AudioPlayer } from 'src/shared/components/AudioPlayer';

import { useUpdatePageProgressMutation } from '../documents/updatePageProgress.generated';

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

interface AudioPlayerProps extends PageProps {
    page: ProgramPageFragment;
}

export const AudioPage: FC<AudioPlayerProps> = ({
    page,
    onNavigateNext,
    onNavigatePrev,
    navigationComponent,
}) => {
    const [updatePageProgress] = useUpdatePageProgressMutation();

    if (!page.audioFile) {
        return (
            <Page
                onNavigatePrev={onNavigatePrev}
                onNavigateNext={onNavigateNext}
                navigationComponent={navigationComponent}
            />
        );
    }

    return (
        <Page
            contentVerticalAlignment={page.contentVerticalAlignment}
            onNavigatePrev={onNavigatePrev}
            onNavigateNext={onNavigateNext}
            navigationComponent={navigationComponent}
        >
            <Container>
                <AudioPlayer
                    audioSrc={page.audioFile}
                    imgSrc={page.image ?? undefined}
                    onProgressSave={async progressPercentage => {
                        await updatePageProgress({
                            variables: {
                                multimediaProgressPercentage: progressPercentage,
                                pageUuid: page.uuid,
                            },
                        });
                    }}
                />
            </Container>
        </Page>
    );
};
